import { useRouter } from 'next/router';

export const useCurrentPath = () => {
  const router = useRouter();
  return router.pathname;
};
